import { gql } from "@apollo/client"

export const DASHBOARD_PGM_GRADUATE_QUERY = gql`
  query DashboardPgmGraduate {
    currentPerson {
      id
      pgmGraduate
    }
  }
`

export const MEMBER_APPLICATION_ELIGIBILITY_QUERY = gql`
  query MemberApplicationEligibility {
    memberApplicationEligibility {
      eligible
      blockingReasons
      experienceCredits {
        total
        threshold
        complete
      }
    }
  }
`
